/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "vehicle_attributes";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface DeviceType {
}

export enum DeviceType_Enum {
  UNKNOWN = 0,
  R3 = 1,
  R35 = 2,
  E1 = 3,
  G27 = 4,
  R47 = 5,
  G47 = 6,
  C18 = 7,
  C93 = 8,
  C38 = 10,
  UNUSED = 11,
  W17 = 12,
  R71 = 13,
  G17 = 14,
  APEX = 15,
  UNRECOGNIZED = -1,
}

export function deviceType_EnumFromJSON(object: any): DeviceType_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return DeviceType_Enum.UNKNOWN;
    case 1:
    case "R3":
      return DeviceType_Enum.R3;
    case 2:
    case "R35":
      return DeviceType_Enum.R35;
    case 3:
    case "E1":
      return DeviceType_Enum.E1;
    case 4:
    case "G27":
      return DeviceType_Enum.G27;
    case 5:
    case "R47":
      return DeviceType_Enum.R47;
    case 6:
    case "G47":
      return DeviceType_Enum.G47;
    case 7:
    case "C18":
      return DeviceType_Enum.C18;
    case 8:
    case "C93":
      return DeviceType_Enum.C93;
    case 10:
    case "C38":
      return DeviceType_Enum.C38;
    case 11:
    case "UNUSED":
      return DeviceType_Enum.UNUSED;
    case 12:
    case "W17":
      return DeviceType_Enum.W17;
    case 13:
    case "R71":
      return DeviceType_Enum.R71;
    case 14:
    case "G17":
      return DeviceType_Enum.G17;
    case 15:
    case "APEX":
      return DeviceType_Enum.APEX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DeviceType_Enum.UNRECOGNIZED;
  }
}

export function deviceType_EnumToJSON(object: DeviceType_Enum): string {
  switch (object) {
    case DeviceType_Enum.UNKNOWN:
      return "UNKNOWN";
    case DeviceType_Enum.R3:
      return "R3";
    case DeviceType_Enum.R35:
      return "R35";
    case DeviceType_Enum.E1:
      return "E1";
    case DeviceType_Enum.G27:
      return "G27";
    case DeviceType_Enum.R47:
      return "R47";
    case DeviceType_Enum.G47:
      return "G47";
    case DeviceType_Enum.C18:
      return "C18";
    case DeviceType_Enum.C93:
      return "C93";
    case DeviceType_Enum.C38:
      return "C38";
    case DeviceType_Enum.UNUSED:
      return "UNUSED";
    case DeviceType_Enum.W17:
      return "W17";
    case DeviceType_Enum.R71:
      return "R71";
    case DeviceType_Enum.G17:
      return "G17";
    case DeviceType_Enum.APEX:
      return "APEX";
    case DeviceType_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseDeviceType(): DeviceType {
  return {};
}

export const DeviceType = {
  encode(_: DeviceType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeviceType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeviceType {
    return {};
  },

  toJSON(_: DeviceType): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceType>, I>>(base?: I): DeviceType {
    return DeviceType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceType>, I>>(_: I): DeviceType {
    const message = createBaseDeviceType();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
